<template>
  <div class="part-search-facets psf">
    <div class="nav-sub psf__content x">
      <div class="psf__header">
      <h4 class="psf__header-text">
        REFINE YOUR SEARCH 
        <b-button class="psf__header-button" @click="toggle()">
          +/-
          </b-button>
      </h4>
      </div>
      <b-collapse id="psf_collapse" :visible="showContent" class="psf__facets-wrapper x">
      <div v-if="isTms">
        <h6 class="nav-sub__sub-header">
          {{ getContentItem("search").toUpperCase() }}
        </h6>
        <div class="mx-2 mb-2">
          <b-input-group class="mt-2">
            <b-form-input 
              v-model="searchTerm"
              size="sm" 
              :placeholder="getContentItem('KeywordSearch')"
              @keyup.enter="addFacet('Part_Description', searchTerm)"
            />
            <b-input-group-append>
              <b-button class="btn-smallGrayButton" @click="addFacet('Part_Description', searchTerm)">
                {{ getContentItem("Go") }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <b-input-group class="mt-2">
            <b-form-input
              v-model="buildDate"
              size="sm"
              :placeholder="getContentItem('TmsBuildDate')"
              @keyup.enter="addFacet('Build_Date', buildDate)"
            />
            <b-input-group-append>
              <b-button class="btn-smallGrayButton" @click="addFacet('Build_Date', buildDate)">
                {{ getContentItem("Go") }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
      <!-- SELECTED FACETS/FILTERS -->
      <div v-if="Object.keys(selectedFacets).length > 0">
        <h6 class="nav-sub__sub-header">
          SELECTED FILTERS
        </h6>
        <ul class="p-0">
          <li v-for="(filter,filterKey) in selectedFacets" :key="filterKey">
            <span class="part-search-facet" @click="removeFacet(filterKey)"><i class="icon-remove-sign" />&nbsp;{{ replace_(filterKey) }} - {{ filter }}</span>
          </li>
        </ul>
      </div>
      <div role="tablist">
        <div v-for="(facet, facetKey) in facets" :key="facetKey">
          <part-search-facets-expand 
            v-if="facet.length > 0"
            :facet="facet" 
            :facet-key="facetKey" 
            :is-tms="isTms" 
            :has-common-parts="hasCommonParts" 
            @add-facet="addFacet"
          />
        </div>
      </div>
      <div v-if="Object.keys(selectedFacets).length === 0 && Object.keys(facets).length === 0" class="no-facets-available-message"> 
        <em>No facets available</em>
      </div>
    </b-collapse>
    </div>
  </div>
</template>

<script>
  import PartSearchFacetsExpand from "@/components/SubMenus/PartSearchFacetsExpand"
  import { mapGetters }         from "vuex"
  import { stringHelper }       from "@/components/mixins/stringHelper"
  import {constants}              from "@/const"

  const addingFacet = true;

  export default {
    name: "PartSearchFacets",
    components: {
      PartSearchFacetsExpand
    },
    mixins: [
      stringHelper
    ],
    props: {
      facets: {
        type: Object,
        default: () => { return {} }
      },
      selectedFacets: {
        type: Object,
        default: () => { return {} }
      },
      isTms: {
        type: Boolean, 
        default: false
      },
      tmsSearchTerm: {
        type: String,
        default: ""
      }
    },
    data: () => ({
      showContent: false,
      showAllFacets: false,
      searchTerm: "",
      buildDate: "",

      // Tms specific data
      commonVsAllPartsText: "",
    }),
    computed: {
      ...mapGetters(["getContentItem"]),
      hasCommonParts() {
        let hasIt = this.IsNotNullOrUndefined(this.facets["Common_Parts"]) 
          || this.IsNotNullOrUndefined(this.facets["All_Parts"]);

        if (hasIt) {
          this.commonOrAllPartsText();
        } 

        return hasIt;
      }
    },
    mounted() {
      this.setShowContent();
    },
    created() {      
      if (this.tmsSearchTerm) {
        this.searchTerm = this.tmsSearchTerm;
      }
    },
    methods: {
      setShowContent() {
        if (window.innerWidth <= constants.BREAKPOINTS.SM) {
          this.showContent = false;
        } else {
          this.showContent = true;
        }
        return this.showContent;
      },
      addFacet(key,value) {
        this.selectedFacets[key] = value;

        if (this.isTms) {
          this.setUpTmsAllVsCommonParts(value);
        }

        this.$emit("facets-updated", addingFacet);
      },
      removeFacet(key) {
          if (this.isTms && key === "Serial_Prefix") {
            delete this.selectedFacets["Serial_Range"]; 
          }
          delete this.selectedFacets[key];
          this.$emit("facets-updated", addingFacet);
      },
      commonOrAllPartsText() {
        if (this.IsNotNullOrUndefined(this.facets["Common_Parts"]) ) {
          this.commonVsAllPartsText = "SHOW ALL";
        }
        if (this.IsNotNullOrUndefined(this.facets["All_Parts"]) ) {
          this.commonVsAllPartsText = "SHOW COMMON";
        }
      },
      setUpTmsAllVsCommonParts(value) {
        // KVP of 'com: 1' results in overriding common parts with all parts
        // this is only relevent for TMS facets. 

        // User on Common_Parts moving to All_Parts
        if (value === "Common_Parts") {
          this.selectedFacets["com"] = 1;
        }
        // User on All_Parts moving to Common_Parts
        if (value === "All_Parts") {
          delete this.selectedFacets["com"];
        }
      },
      toggle(){      
        this.showContent = !this.showContent;
      }
    }
  }
</script>

<style lang="scss">
.part-search-facets{
  margin: 0%;
  width: 100%;
  .nav-sub{
    width: initial;
    min-width: 100%;
  }
}
.no-facets-available-message{
  padding: 12px;
  text-align: center;
}
.part-search-facet{
  cursor: pointer;
}


.psf__header{
  width: 100%;
  position: relative;
}


.psf__header-text{
  color: yellow;
}

.psf__header-button{
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
}


.psf__content.x{
  padding-bottom: 0;
}
</style>